$(document).on("click",".template-name-collection .product-shop-back-in-stock-submit-popup, .template-index .product-shop-back-in-stock-submit-popup", function (e) {
    e.preventDefault();
    var $this = $(this);
    var $emailInput2 = $("#bis-email-field_popup");
    var email = $emailInput2.val();
    var productID = $emailInput2.attr("data-product-id");
    var variantID = $emailInput2.attr("data-variant-id");
    BIS.create(email, variantID, productID).then(function (data) {
        var msg = "";
        if (data.status == "OK") {
            msg = "WE GOT YOU!";
            $emailInput2.parent().addClass("bis-submitted");
            $(".product-shop-back-in-stock-submit-popup").text("YOU’RE ON THE WAITLIST!");
            $emailInput2.val("");
            $emailInput2.css("display", "none");
            $emailInput2.attr("placeholder", msg);
        } else {
            var error = "";
            for (var k in data.errors) {
                error += k + " " + data.errors[k].join();
            }
            if (error.indexOf("already") >= 0) {
                msg = "WE GOT YOU!";
                $emailInput2.parent().addClass("bis-submitted");
                $emailInput2.css("display", "none");
                $emailInput2.blur();
                $(".product-shop-back-in-stock-submit-popup").text("YOU’RE ON THE WAITLIST!");
                
                $emailInput2.attr("placeholder", msg);
            } else if (error.indexOf("invalid") >= 0) {
                msg = "Invalid email";
                $emailInput2.val("");
                $emailInput2.blur();
                $emailInput2.attr("placeholder", msg);
            } else {
                msg = "error";
                $emailInput2.val("");
                $emailInput2.blur();
                $emailInput2.attr("placeholder", msg);
            }
        }
    });
});

$(".product-shop-back-in-stock-email").keypress(function (e) {
    if (e.which == 13) {
        $(".product-shop-back-in-stock-submit").click();
        $(".product-shop-back-in-stock-email").blur();
        return !1;
    }
});

$(document).on("keydown", "#bis-email-field_popup", function (e) {
    if (e.key == "Enter") { // Check if the key pressed was the Enter key
        e.preventDefault();
        $(".template-name-collection .product-shop-back-in-stock-submit-popup").click(); // Trigger the click event
    }
});



$(document).on("click", ".js-product-back-in-stock-submit", function () {
    var $this = $(this);
    if ($this.parents(".product-shop-function-bar").hasClass("is_stuck")) {
        $("html, body").animate({ scrollTop: 0 }, 600, "easeOutExpo");
    } else {
        var $emailInput = $(".product-shop-back-in-stock-email");
        var email = $emailInput.val();
        var productID = $this.attr("data-product-id");
        var variantID = $this.attr("data-variant-id");
        $("input.product-shop-back-in-stock-email.block-fullwidth").fadeOut().fadeIn();
    }
});
$(document).on("click", ".template-product .product-shop-back-in-stock-submit, .template-article .product-shop-back-in-stock-submit", function () {
    var $this = $(this);
    var $emailInput = $this.parents('.product-back-in-stock').find(".product-shop-back-in-stock-email");
    var $addToCartBtn = $(".product-shop-add-to-cart");
    var email = $emailInput.val();
    var productID = $addToCartBtn.attr("data-product-id");
    var variantID = $addToCartBtn.attr("data-variant-id");
    BIS.create(email, variantID, productID).then(function (data) {
        var msg = "";
        if (data.status == "OK") {
            msg = "THANK YOU!";
            $("input.product-shop-back-in-stock-email").val("");
            $(".product-shop-back-in-stock-fields").addClass("product-waitlisted");
            $(".product-shop-back-in-stock-submit").text("YOU’RE ON THE WAITLIST!");
        } else {
            var error = "";
            for (var k in data.errors) {
                error += k + " " + data.errors[k].join();
            }
            if (error.indexOf("already") >= 0) {
                msg = "THANK YOU!";
                $("input.product-shop-back-in-stock-email").val("");
                $("input.product-shop-back-in-stock-email").blur();
                $(".product-shop-back-in-stock-fields").addClass("product-waitlisted");
                $(".product-shop-back-in-stock-submit").text("YOU’RE ON THE WAITLIST!");
            } else if (error.indexOf("invalid") >= 0) {
                msg = "invalid email";
                $("input.product-shop-back-in-stock-email").val("");
                $("input.product-shop-back-in-stock-email").blur();
                $("input.product-shop-back-in-stock-email").attr("placeholder", msg);
            } else {
                msg = "error";
                $("input.product-shop-back-in-stock-email").val("");
                $("input.product-shop-back-in-stock-email").blur();
                $("input.product-shop-back-in-stock-email").attr("placeholder", msg);
            }
        }
    });
});



$(document).on('click', '.popup-close-waitlist', function () {
    $('.waitlist-popup').fadeOut(400).attr('aria-hidden', 'true');

    setTimeout(function() {
        $('.waitlist-popup-form-fields').removeClass('bis-submitted');
        $(".product-shop-back-in-stock-submit-popup").text("SIGN UP");
        $("#bis-email-field_popup").attr('placeholder', 'Your email').removeAttr('style');
    },1000)
    
});